import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, HardHat, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { StickyMobileBar } from "@/components/site/StickyMobileBar";
import { company, services } from "@/data/content";

const titles = {
  "/realizace": "Realizace",
  "/realizace/detail-projektu": "Detail projektu",
  "/ochrana-osobnich-udaju": "Ochrana osobních údajů",
  "/cookies": "Zásady cookies",
};

export default function PlaceholderPage() {
  const { pathname } = useLocation();
  const service = services.find((s) => s.link === pathname);
  const title = service ? service.title : titles[pathname] || "Stránka";

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-24 lg:pt-28">
        <section className="mx-auto max-w-7xl px-5 py-16 lg:px-10 lg:py-24">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-accent">
            {service ? "Služba" : "Goalstav"}
          </p>
          <h1 className="mt-3 text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
            {title}
          </h1>

          <div className="mt-10 grid grid-cols-1 gap-10 lg:grid-cols-12">
            <div className="lg:col-span-6">
              <div className="flex items-center gap-3 rounded-md border border-border bg-card px-5 py-4" data-testid="page-in-progress">
                <HardHat className="h-5 w-5 shrink-0 text-accent" />
                <p className="text-sm text-muted-foreground">
                  Stránku právě připravujeme. Vše důležité zatím najdete na
                  hlavní stránce nebo nám rovnou zavolejte.
                </p>
              </div>
              {service && (
                <p className="mt-6 max-w-lg text-base leading-relaxed text-muted-foreground">
                  {service.description}
                </p>
              )}
              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <Button asChild className="h-12 bg-primary px-6 text-primary-foreground hover:bg-primary/90">
                  <Link to="/#kontakt">Získat nezávaznou nabídku</Link>
                </Button>
                <Button asChild variant="outline" className="h-12 border-foreground/25 bg-transparent px-6 text-foreground hover:bg-foreground/5 hover:text-foreground">
                  <a href={company.phoneHref}>
                    <Phone className="mr-1 h-4 w-4" /> {company.phone}
                  </a>
                </Button>
              </div>
              <Link
                to="/"
                data-testid="back-home-link"
                className="mt-10 inline-flex items-center gap-2 text-sm font-semibold text-accent transition-colors hover:text-accent/80"
              >
                <ArrowLeft className="h-4 w-4" /> Zpět na hlavní stránku
              </Link>
            </div>
            {service && (
              <figure className="lg:col-span-6">
                <img
                  src={service.image}
                  alt={service.imageAlt}
                  className="h-72 w-full rounded-md object-cover lg:h-[400px]"
                />
                <figcaption className="mt-2 text-xs text-muted-foreground">
                  {service.imageAlt}
                </figcaption>
              </figure>
            )}
          </div>
        </section>
      </main>
      <Footer />
      <StickyMobileBar />
    </div>
  );
}
